import { StarIcon } from "@heroicons/react/24/solid"
import React from "react"
import { twMerge } from "tailwind-merge"

const ReviewStars = ({ rating, starClassName, filledColor, emptyColor }) => {
  rating = Math.round(rating)

  // Use theme colors if provided, otherwise fallback to default Tailwind classes
  const filledStarClass = filledColor ? "" : "text-orange"
  const emptyStarClass = emptyColor ? "" : "text-gray"

  const filledStarStyle = filledColor ? { color: filledColor } : {}
  const emptyStarStyle = emptyColor ? { color: emptyColor } : {}

  return (
    <div className="flex gap-0.5">
      {[...Array(rating)].map((item, index) => (
        <StarIcon key={index} className={twMerge("h-5 w-5", filledStarClass, starClassName)} style={filledStarStyle} />
      ))}
      {rating < 5 && (
        <>
          {[...Array(5 - rating)].map((item, index) => (
            <StarIcon
              key={index}
              className={twMerge("h-5 w-5", emptyStarClass, starClassName)}
              style={emptyStarStyle}
            />
          ))}
        </>
      )}
    </div>
  )
}

export default ReviewStars
